import React from 'react';
import PausasLanding from '../../components/public/PausasLanding.jsx';

export function PublicLanding() {
  return <PausasLanding />;
}

export default PublicLanding;

